import React from "react";
import './Landing.css';
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Landing = () => {

    const navigate = useNavigate();

    // Function to handle navigation
    const handleRedirect = () => {
     navigate("/contact-us");
   };

  return (
    <div className="rt-landing-container">
      <div className="rt-landing-content">
        <div className="rt-landing-heading">Red Teaming Exercise
        </div>
        <p className="rt-landing-description">Elevate your security by anticipating threats from a different perspective. 
        </p>
        <Button variant="contained" className="rt-landing-ctaBtn" onClick={handleRedirect}>Connect With Us Today</Button>
      </div>
    </div>
  )
}

export default Landing;